/**
 * CustomerSpeed.API
 * API that manages account-specific speed limit overrides.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * DTO representing a directional speed limit for a segment. `SpeedLimit` is the speed converted to the customer\'s preferred unit. `SpeedUnit` reflects the customer\'s preferred unit. `SpeedLimitInKmh` is the canonical speed limit in km/h.
 */
export interface SegmentDirectionalSpeedLimitDto {
  /**
   * The direction of travel. Serializes as UPPER_SNAKE_CASE (FORWARD or BACKWARD).
   */
  direction: SegmentDirectionalSpeedLimitDto.DirectionEnum;
  /**
   * The direction sign along the road geometry (\"+\" = Forward, \"-\" = Backward).
   */
  directionAttribute: SegmentDirectionalSpeedLimitDto.DirectionAttributeEnum;
  /**
   * The speed limit converted to the customer\'s preferred unit.
   */
  speedLimit: number;
  /**
   * The customer\'s preferred speed unit. Serializes as a human-readable string (e.g. \"mph\", \"km/h\").
   */
  speedUnit: SegmentDirectionalSpeedLimitDto.SpeedUnitEnum;
  /**
   * The canonical speed limit in km/h, as reported by the mapping service.
   */
  speedLimitInKmh: number;
  /**
   * Indicates the origin of the speed value: `HERE` for the mapping service, `GLOBAL_OVERRIDE` for a blacklist override, or `CUSTOMER_OVERRIDE` for a customer-specific override.
   */
  speedSource: SegmentDirectionalSpeedLimitDto.SpeedSourceEnum;
  /**
   * Start of the customer override window. Populated only when SpeedSource is CUSTOMER_OVERRIDE. Null on HERE and GLOBAL_OVERRIDE rows.
   */
  startDate?: string | null;
  /**
   * End of the customer override window. Populated only when SpeedSource is CUSTOMER_OVERRIDE. Null on HERE and GLOBAL_OVERRIDE rows.
   */
  endDate?: string | null;
}
export namespace SegmentDirectionalSpeedLimitDto {
  export type DirectionEnum = 'BACKWARD' | 'FORWARD';
  export const DirectionEnum = {
    Backward: 'BACKWARD' as DirectionEnum,
    Forward: 'FORWARD' as DirectionEnum
  };
  export type DirectionAttributeEnum = '+' | '-';
  export const DirectionAttributeEnum = {
    Plus: '+' as DirectionAttributeEnum,
    Minus: '-' as DirectionAttributeEnum
  };
  export type SpeedUnitEnum = 'Knots' | 'MilesPerHour' | 'CentimetersPerSecond' | 'KilometersPerHour';
  export const SpeedUnitEnum = {
    Knots: 'Knots' as SpeedUnitEnum,
    MilesPerHour: 'MilesPerHour' as SpeedUnitEnum,
    CentimetersPerSecond: 'CentimetersPerSecond' as SpeedUnitEnum,
    KilometersPerHour: 'KilometersPerHour' as SpeedUnitEnum
  };
  export type SpeedSourceEnum = 'HERE' | 'GLOBAL_OVERRIDE' | 'CUSTOMER_OVERRIDE';
  export const SpeedSourceEnum = {
    Here: 'HERE' as SpeedSourceEnum,
    GlobalOverride: 'GLOBAL_OVERRIDE' as SpeedSourceEnum,
    CustomerOverride: 'CUSTOMER_OVERRIDE' as SpeedSourceEnum
  };
}
